import { ReactNode } from 'react';

interface AdminLayoutProps {
  title: string;
  description: string;
  action?: ReactNode;
  titleExtra?: ReactNode;
  children: ReactNode;
}

function AdminLayout({ title, description, action, titleExtra, children }: AdminLayoutProps) {
  // 65px is the admin header: h-16 plus its bottom border. The section tabs that used to sit under
  // it are now a sidebar, which scrolls independently of this region.
  return (
    <div className="h-[calc(100dvh-65px)] min-w-0 max-w-full overflow-auto">
      <div className="divide-y divide-gray-200">
        <div className="container mx-auto max-w-7xl py-8">
          <div className="flex flex-wrap items-start justify-between gap-4">
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <h1 className="text-[32px] font-medium tracking-tight text-gray-900">{title}</h1>
                {titleExtra}
              </div>
              <p className="mt-2 break-words text-sm text-gray-500">{description}</p>
            </div>
            {action && <div className="min-w-0 max-w-full">{action}</div>}
          </div>
        </div>

        <div>
          <div className="container mx-auto min-w-0 max-w-7xl py-8">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;
